import { useCalculator } from '../state/CalculatorProvider';
import { renderStepItem } from '../fields/renderItem';

export function IntroScreen() {
  const { config, state, attemptAdvance, setValue } = useCalculator();
  if (!config.intro) return null;
  const { heading, body, ctaLabel, fields, media } = config.intro;

  return (
    <div className="hsab-calc__intro">
      {media}
      <h2 className="hsab-calc__intro-heading">{heading}</h2>
      {body && <div className="hsab-calc__intro-body">{body}</div>}
      {fields?.map((field, i) => renderStepItem(field, i, state.values, setValue))}
      <button type="button" className="hsab-calc__intro-cta" onClick={attemptAdvance}>
        {ctaLabel}
      </button>
    </div>
  );
}
